<template>
<div>
    <!-- <Breadcrumb :options="crumbOptions"></Breadcrumb> -->
  <div class="backStack-issue-wrap informationCreate">
    <From ref="form" layoutType="grid" :isErrorMessage="false" :optionList="formRows" :formRules="formRules" :defaultModel="defaultModel"> </From>
    <div class="backStack-issue-footer-wrap">
      <div class="submit-wrap">
        <a-button class="submit-audit" @click="invokeApi" :loading="loading">编辑交易公告</a-button>
      </div>
    </div>
  </div>
</div>

</template>

<script>
// import Breadcrumb from '@/components/common/Breadcrumb'
import From from '../../components/formTable/form.vue'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { formRules, formRows } from './configs/configs.js'
import { getAnnounceDetail, editAnnounceInfos } from '@/api/announceApi.js'
import { getCurrentCrumb } from '@/utils/crumb.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      loading: false,
      crumbOptions: [],
      formRows, // 表单item配置
      formRules, // 表单校验规则配置
      defaultModel: {}, // 默认值
      editId: null
    }
  },
  components: {
    From,
    // Breadcrumb
  },
  created() {
    this.initSetting()
  },
  methods: {
    initSetting() {
      const { id } = this.$route.query
      this.editId = id
      this.getAnnounceInfos(id)
    },
    // 单独获取编辑
    async getAnnounceInfos(id) {
      const { data } = await getAnnounceDetail(id)
      const { fileVo, ...otherParams } = data
      this.defaultModel = { picPath: fileVo, ...otherParams }
    },
    // 处理面包屑
    settingCrumb(type) {
      const { path } = this.$route
      const newPath = path.replace('operation', type)
      const crumbOptions = getCurrentCrumb(newPath)
      this.crumbOptions = crumbOptions
    },
    clearForm() {
      this.defaultModel = { operationType: '1' }
    },
    async invokeApi() {
      const ref = this.$refs.form
      const validate = ref.validatedForm() // 校验表单是否有填写
      if (!validate) return
      try {
        const { picPath, ...formModel} = ref.formModel
        const pic = this.handlerPicPathIds(picPath).join(',')
        const params = {
          ...formModel,
          pic,
          id: this.editId
        }
        const { code, msg } = await editAnnounceInfos(params)
        this.$apiStatusHandler(code, msg)
        this.$router.push({ name:'informationAnnounce' })
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      } finally {
        this.loading = false
      }
    },
    handlerPicPathIds(picPath) {
      if(!picPath) return []
      return picPath.reduce((pre, item) => {
        if(item.response) {
          const {fileId} = item.response.data[0]
          pre.push(fileId)
        } else {
          pre.push(item.id)
        }
        return pre
      }, [])
    },
  }
}
</script>
